const getCsrfToken = () =>
    document
        .querySelector(
            'meta[name="csrf-token"]'
        )
        ?.getAttribute('content');

const getReactionDefinitions = (
    container
) => {
    if (container.reactionDefinitions) {
        return container.reactionDefinitions;
    }

    try {
        container.reactionDefinitions =
            JSON.parse(
                container.dataset
                    .reactionDefinitions
                || '{}'
            );
    } catch (error) {
        console.error(
            'Reaction definitions could not be parsed.',
            error
        );

        container.reactionDefinitions = {};
    }

    return container.reactionDefinitions;
};

window.updateMessageReactionUi = (
    container,
    data
) => {
    const summary =
        container.querySelector(
            '[data-reaction-summary]'
        );

    if (!summary) {
        return;
    }

    summary.innerHTML = '';

    const definitions =
        data.reaction_definitions || {};

container.reactionDefinitions =
    definitions;

    const counts =
        data.reaction_counts || {};

    Object.entries(definitions)
        .forEach(
            ([
                reaction,
                definition,
            ]) => {
                const count =
                    Number(
                        counts[reaction] || 0
                    );

                if (count <= 0) {
                    return;
                }

                const button =
                    document.createElement(
                        'button'
                    );

                button.type = 'button';

                button.className =
                    'inline-flex items-center gap-1.5 rounded-full border border-white/15 bg-white/10 px-3 py-1.5 text-xs font-bold text-white hover:bg-white/15';

                button.dataset
    .messageReactionMembers =
    '';

                button.dataset.reaction =
                    reaction;

                button.setAttribute(
                    'aria-label',
                    definition.label
                    || reaction
                );

                const emoji =
                    document.createElement(
                        'span'
                    );

                emoji.setAttribute(
                    'aria-hidden',
                    'true'
                );

                emoji.textContent =
                    definition.emoji || '';

                const countElement =
                    document.createElement(
                        'span'
                    );

                countElement.textContent =
                    String(count);

                button.appendChild(
                    emoji
                );

                button.appendChild(
                    countElement
                );

                summary.appendChild(
                    button
                );
            }
        );

    container
        .querySelectorAll(
            '[data-message-reaction]'
        )
        .forEach(
            (button) => {
                const reaction =
                    button.dataset.reaction;

                const selected =
                    reaction
                    === data.selected_reaction;

                button.setAttribute(
                    'aria-pressed',
                    selected
                        ? 'true'
                        : 'false'
                );

                button.classList.toggle(
                    'border-cyan-300',
                    selected
                );

                button.classList.toggle(
                    'bg-cyan-400/20',
                    selected
                );

                button.classList.toggle(
                    'ring-2',
                    selected
                );

                button.classList.toggle(
                    'ring-cyan-300/40',
                    selected
                );

                button.classList.toggle(
                    'border-white/15',
                    ! selected
                );

                button.classList.toggle(
                    'bg-white/10',
                    ! selected
                );
            }
        );
};
const createMemberAvatar = (
    member
) => {
    if (member.photo_url) {
        const image =
            document.createElement(
                'img'
            );

        image.src =
            member.photo_url;

        image.alt =
            '';

        image.className =
            'h-10 w-10 rounded-full object-cover';

        return image;
    }

    const fallback =
        document.createElement(
            'span'
        );

    fallback.className =
        'flex h-10 w-10 items-center justify-center rounded-full bg-gradient-to-br from-fuchsia-600 to-orange-500 text-sm font-black text-white';

    fallback.textContent =
        member.name
            ?.trim()
            .charAt(0)
            .toUpperCase()
        || '?';

    return fallback;
};

const renderReactionMembers = (
    container,
    reaction,
    members
) => {
    const panel =
        container.querySelector(
            '[data-reaction-members-panel]'
        );

    const title =
        container.querySelector(
            '[data-reaction-members-title]'
        );

    const list =
        container.querySelector(
            '[data-reaction-members-list]'
        );

    if (
        !panel
        || !title
        || !list
    ) {
        return;
    }

    const definitions =
        container.reactionDefinitions
        || {};

    const definition =
        definitions[reaction]
        || {};

    title.textContent =
        `${definition.emoji || ''} `
        + `${definition.label || 'Reactions'}`;

    list.innerHTML = '';

    if (members.length === 0) {
        const empty =
            document.createElement(
                'p'
            );

        empty.className =
            'text-sm text-slate-400';

        empty.textContent =
            'No members currently have this reaction.';

        list.appendChild(
            empty
        );
    } else {
        members.forEach(
            (member) => {
                const row =
                    document.createElement(
                        'a'
                    );

                row.href =
                    member.profile_url;

                row.className =
                    'flex items-center gap-3 rounded-xl px-3 py-2 transition hover:bg-white/10';

                const avatar =
                    createMemberAvatar(
                        member
                    );

                const name =
                    document.createElement(
                        'span'
                    );

                name.className =
                    'min-w-0 flex-1 truncate text-sm font-bold text-white';

                name.textContent =
                    member.name;

                row.appendChild(
                    avatar
                );

                row.appendChild(
                    name
                );

                list.appendChild(
                    row
                );
            }
        );
    }

    panel.classList.remove(
        'hidden'
    );
};

const loadReactionMembers = async (
    container,
    reaction
) => {
    const template =
        container.dataset
            .reactionMembersUrlTemplate;

    if (!template) {
        return;
    }

    if (!container.reactionMembersCache) {
        container.reactionMembersCache =
            new Map();
    }

    if (
        container
            .reactionMembersCache
            .has(reaction)
    ) {
        renderReactionMembers(
            container,
            reaction,
            container
                .reactionMembersCache
                .get(reaction)
        );

        return;
    }

    const panel =
        container.querySelector(
            '[data-reaction-members-panel]'
        );

    const title =
        container.querySelector(
            '[data-reaction-members-title]'
        );

    const list =
        container.querySelector(
            '[data-reaction-members-list]'
        );

    if (
        !panel
        || !title
        || !list
    ) {
        return;
    }

    title.textContent =
        'Loading reactions…';

    list.innerHTML = '';

    panel.classList.remove(
        'hidden'
    );

    const url =
        template.replace(
            '__REACTION__',
            encodeURIComponent(
                reaction
            )
        );

    try {
        const response =
            await fetch(
                url,
                {
                    credentials:
                        'same-origin',

                    headers: {
                        Accept:
                            'application/json',

                        'X-Requested-With':
                            'XMLHttpRequest',
                    },
                }
            );

        if (!response.ok) {
    const errorText =
        await response.text();

    console.error(
        'Reaction members request failed.',
        {
            status: response.status,
            response: errorText,
            url,
        }
    );

    throw new Error(
        `Unable to load reaction members (${response.status}).`
    );
}

        const data =
            await response.json();

        const members =
            Array.isArray(
                data.members
            )
                ? data.members
                : [];

        container
            .reactionMembersCache
            .set(
                reaction,
                members
            );

        renderReactionMembers(
            container,
            reaction,
            members
        );
    } catch (error) {
        console.error(
            'Loading reaction members failed.',
            error
        );

        title.textContent =
            'Reactions';

        list.innerHTML = '';

        const message =
            document.createElement(
                'p'
            );

        message.className =
            'text-sm text-red-300';

        message.textContent =
            'Reaction members could not be loaded.';

        list.appendChild(
            message
        );
    }
};
const toggleReaction = async (
    container,
    reaction
) => {
    const url =
        container.dataset
            .reactionUrl;

    const csrfToken =
        getCsrfToken();

    if (
        ! url
        || ! csrfToken
    ) {
        return;
    }

    container.dataset.loading =
        'true';

    try {
        const response =
            await fetch(
                url,
                {
                    method: 'POST',

                    credentials:
                        'same-origin',

                    headers: {
                        Accept:
                            'application/json',

                        'Content-Type':
                            'application/json',

                        'X-Requested-With':
                            'XMLHttpRequest',

                        'X-CSRF-TOKEN':
                            csrfToken,
                    },

                    body:
                        JSON.stringify({
                            reaction,
                        }),
                }
            );

        if (!response.ok) {
            return;
        }

        const data =
            await response.json();

container
    .reactionMembersCache
    ?.clear();

        window.updateMessageReactionUi(
            container,
            data
        );

const details =
    container.querySelector(
        'details'
    );

if (details) {
    details.open = false;
}
    } catch (error) {
        console.error(
            'Message reaction failed.',
            error
        );
    } finally {
        delete container
            .dataset
            .loading;
    }
};

document.addEventListener(
    'click',
    (event) => {
        const target =
            event.target;

        if (
            !(target instanceof Element)
        ) {
            return;
        }

document
    .querySelectorAll(
        '[data-message-reactions] details'
    )
    .forEach(
        (details) => {
            if (
                details.contains(
                    target
                )
            ) {
                return;
            }

            details.open = false;
        }
    );

        const closeButton =
            target.closest(
                '[data-reaction-members-close]'
            );

        if (closeButton) {
            const panel =
                closeButton.closest(
                    '[data-reaction-members-panel]'
                );

            panel?.classList.add(
                'hidden'
            );

            return;
        }

        const membersButton =
            target.closest(
                '[data-message-reaction-members]'
            );

        if (membersButton) {
            const container =
                membersButton.closest(
                    '[data-message-reactions]'
                );

            const reaction =
                membersButton.dataset
                    .reaction;

            if (
                container
                && reaction
            ) {
                loadReactionMembers(
                    container,
                    reaction
                );
            }

            return;
        }

        const reactionButton =
            target.closest(
                '[data-message-reaction]'
            );

        if (!reactionButton) {
            return;
        }

        const container =
            reactionButton.closest(
                '[data-message-reactions]'
            );

        if (
            !container
            || container.dataset.loading
                === 'true'
        ) {
            return;
        }

        const reaction =
            reactionButton.dataset
                .reaction;

        if (!reaction) {
            return;
        }

        toggleReaction(
            container,
            reaction
        );
    }
);

document.addEventListener(
    'toggle',
    (event) => {
        const details =
            event.target;

        if (
            !(details instanceof HTMLDetailsElement)
            || !details.open
            || !details.closest(
                '[data-message-reactions]'
            )
        ) {
            return;
        }

        document
            .querySelectorAll(
                '[data-message-reactions] details'
            )
            .forEach(
                (otherDetails) => {
                    if (
                        otherDetails !== details
                    ) {
                        otherDetails.open =
                            false;
                    }
                }
            );
    },
    true
);

document.addEventListener(
    'keydown',
    (event) => {
        if (
            event.key !== 'Escape'
        ) {
            return;
        }

        document
            .querySelectorAll(
                '[data-message-reactions] details'
            )
            .forEach(
                (details) => {
                    details.open = false;
                }
            );
    }
);